// services/auditoria/auditoria.service.ts

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { InterfazAuditoriaResponse } from '../../models/interfaz-auditoria/interfaz-auditoria-response';
import { InterfazAuditoriaRequest } from '../../models/interfaz-auditoria/interfaz-auditoria-request';

@Injectable({
  providedIn: 'root',
})
export class InterfazAuditoriaService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.INTERFAZ_PERFILAMIENTO}`;

  constructor(private http: HttpClient) {}

  validar(
    request: InterfazAuditoriaRequest,
  ): Observable<InterfazAuditoriaResponse[]> {
    return this.http.post<InterfazAuditoriaResponse[]>(this.apiUrl, request);
  }
}
